export const KPI_WITH_TARGET = ({ processedDashboardData, targetValue, title, metric, icon, range, theme }) => {
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData <= targetValue) ? '#28a745' : '#ff9800'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 8px 0', letterSpacing: '0.5px' }}>
                        {title}
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData <= targetValue) ? '#28a745' : '#ff9800',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData || 0}
                        </span>
                        <span style={{ fontSize: '16px', color: '#6c757d', fontWeight: '500' }}>{metric}</span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData <= targetValue) ? 'rgba(40, 167, 69, 0.1)' : 'rgba(255, 152, 0, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    fontSize: '24px'
                }}>
                    {icon}
                </div>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData <= targetValue) ? '#28a745' : '#ff9800',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                {range} • Target: ≤ {targetValue.toFixed(2)} {metric}
            </div>
        </div>
    )
}